import React, { useEffect, useState } from "react";
import "./AddNewExpense.css";
import Header from "../Header/Header";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddNewExpense = () => {
  const currentDate = new Date().toISOString().split("T")[0];
  const [activeTab, setActiveTab] = useState("expense");
  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [isCategoryLoading, setIsCategoryLoading] = useState(true);
  const [isSubCategoryLoading, setIsSubCategoryLoading] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [expenseFormData, setExpenseFormData] = useState({
    date: currentDate,
    category: "",
    subCategory: "",
    description: "",
    amount: "",
    frontSideReceipt: null,
    backSideReceipt: null,
  });
  const [incomeFormData, setIncomeFormData] = useState({
    date: currentDate,
    source: "",
    description: "",
    amount: "",
  });
  const [imagePreviews, setImagePreviews] = useState({
    frontSideReceipt: null,
    backSideReceipt: null,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("tokenexpense");
    if (!token) {
      navigate("/welcome");
    }
  }, [navigate]);

  const handleExpenseChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "category") {
      const selectedCategory = category.find((cat) => cat.name === value);
      setSelectedCategoryId(selectedCategory?._id || "");
      setSubCategory([]);
      if (selectedCategory?._id) {
        fetchSubCategory(selectedCategory._id);
      }
    }
  
    setExpenseFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleIncomeChange = (e) => {
    const { name, value } = e.target;
    setIncomeFormData((prev) => ({ ...prev, [name]: value }));
  };

  // const handleExpenseFileChange = (e) => {
  //   const { name, files } = e.target;
  //   setExpenseFormData((prevState) => ({
  //     ...prevState,
  //     [name]: files[0],
  //   }));
  // };

  const handleExpenseFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];
    if (file) {
      setExpenseFormData((prevState) => ({
        ...prevState,
        [name]: file,
      }));
      // Set preview
      const reader = new FileReader();
      reader.onload = () => {
        setImagePreviews((prev) => ({ ...prev, [name]: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const clearExpense = () => {
    setExpenseFormData({
      date: currentDate,
      category: "",
      subCategory:"",
      description: "",
      amount: "",
      frontSideReceipt: null,
      backSideReceipt: null,
    });
    setSelectedCategoryId("");
    setSubCategory([]);
    setImagePreviews({
      frontSideReceipt: null,
      backSideReceipt: null,
    });
  };

  const clearIncome = () => {
    setIncomeFormData({
      date: currentDate,
      source: "",
      description: "",
      amount: "",
    });
  };

  const fetchCategory = async () => {
    try {
      setIsCategoryLoading(true);
      const token = localStorage.getItem("tokenexpense");
      const response = await axios.get(
        `https://expense.dpstrust.in/api/category/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    console.log("Category fetched successfully", response.data.data.categoryData)
    setCategory(response.data.data.categoryData);
    } catch (error) {
      console.error("Error fetching category:", error);
    } finally {
      setIsCategoryLoading(false);
    }
  };

  useEffect(()=>{
    fetchCategory();
  },[]);

  const fetchSubCategory = async (categoryId) => {
    try {
      setIsSubCategoryLoading(true);
      const token = localStorage.getItem("tokenexpense");
      const response = await axios.get(
        `https://expense.dpstrust.in/api/subcategory/all?categoryId=${categoryId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("SubCategory fetched successfully", response.data.data.subcategories);
      setSubCategory(response.data.data.subcategories || []);
    } catch (error) {
      console.error("Error fetching subcategory:", error);
    } finally {
      setIsSubCategoryLoading(false);
    }
  };

  const handleSaveExpense = async () => {
    const token = localStorage.getItem("tokenexpense");
    if (!token) {
      toast.error("Please log in again.", {
        position: "top-right",
        autoClose: 5000,
        theme: "colored",
        transition: Bounce,
      });
      return;
    }

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    };

    const data = new FormData();
    data.append("date", expenseFormData.date);
    data.append("category", expenseFormData.category);
    data.append("subCategory", expenseFormData.subCategory);
    data.append("description", expenseFormData.description || "");
    data.append("amount", expenseFormData.amount);
    if (expenseFormData.frontSideReceipt) {
      data.append("frontSideReceipt", expenseFormData.frontSideReceipt);
    }
    if (expenseFormData.backSideReceipt) {
      data.append("backSideReceipt", expenseFormData.backSideReceipt);
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/expense`,
        data,
        config
      );
      toast.success(response?.data?.message || "Expense added successfully!", {
        position: "top-right",
        autoClose: 5000,
        theme: "light",
        transition: Bounce,
      });
     clearExpense();
    } catch (error) {
      console.error("Error adding expense:", error);
      toast.error(error?.response?.data?.message || "Failed to add expense.", {
        position: "top-right",
        autoClose: 5000,
        theme: "colored",
        transition: Bounce,
      });
    }
  };

  const handleSaveIncome = async () => {
    const token = localStorage.getItem("tokenexpense");
    if (!token) {
      alert("Please log in again.");
      return;
    }

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const data = {
      source: incomeFormData.source,
      date: incomeFormData.date,
      amount: incomeFormData.amount,
      description: incomeFormData.description || "",
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/income`,
        data,
        config
      );
      toast.success(response?.data?.message || "Income added successfully!", {
        position: "top-right",
        autoClose: 5000,
        theme: "light",
        transition: Bounce,
      });
      clearIncome();
    } catch (error) {
      console.error("Error adding income:", error);
      toast.error(error?.response?.data?.message || "Failed to add income.", {
        position: "top-right",
        autoClose: 5000,
        theme: "colored",
        transition: Bounce,
      });
    }
  };

  return (
    <>
      <ToastContainer />
      <Header heading="Add Expense" />
      {/* Tab navigation */}
      <div className="expense-container">
       {/* <div style={{ display: "flex", paddingInline: "20px" }}>
          <div className="tab-container">
            <button
              className={`tab-button ${
                activeTab === "expense" ? "active" : ""
              }`}
              onClick={() => setActiveTab("expense")}
            >
              Expense
            </button>
            <button
              className={`tab-button ${activeTab === "income" ? "active" : ""}`}
              onClick={() => setActiveTab("income")}
            >
              Income
            </button>
          </div>
        </div> */}
        {activeTab === "expense" && (
          <div>
            <div style={{ display: "flex", flexDirection: "column" , paddingTop:"30px"}}>
              <input
                className="inputfield"
                type="date"
                name="date"
                value={expenseFormData.date}
                onChange={handleExpenseChange}
              />
              <select
                className="inputfield"
                name="category"
                value={expenseFormData.category}
                onChange={handleExpenseChange}
                disabled={isCategoryLoading}
              >
                <option value="">Select Category</option>
                {category.map((data) => (
          <option value={data.name} key={data._id}>
            {data.name}
          </option>
        ))}
              </select>
              <select
                className="inputfield"
                name="subCategory"
                value={expenseFormData.subCategory}
                onChange={handleExpenseChange}
                disabled={!selectedCategoryId || isSubCategoryLoading}
              >
                <option value="">Select Sub-Category</option>
        {subCategory.map((subData) => (
          <option value={subData.name} key={subData._id}>
            {subData.name}
          </option>
        ))}
              </select>
              <input
                className="inputfield"
                type="text"
                name="description"
                placeholder="Description (Optional)"
                value={expenseFormData.description}
                onChange={handleExpenseChange}
              />
              <input
  className="inputfield"
  type="text"
  name="amount"
  placeholder="Total"
  value={expenseFormData.amount}
  onChange={handleExpenseChange}
  onInput={(e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, "");
  }}
/>

            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "20px",
                paddingTop: "0px",
              }}
            >
              <div className="headsecond">Expense receipt images</div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "20px",
                  paddingTop: "10px",
                }}
              >
                <div className="imagesecond">
                  <input
                    type="file"
                    name="frontSideReceipt"
                    className="imagesecondimg"
                    onChange={handleExpenseFileChange}
                  />
                  {imagePreviews.frontSideReceipt && (
                    <img
                      src={imagePreviews.frontSideReceipt}
                      alt="Front Receipt"
                      style={{ width: "100%", marginTop: "10px" }}
                    />
                  )}
                </div>
                <div className="imagesecond1">
                  <input
                    type="file"
                    name="backSideReceipt"
                    className="imagesecondimg"
                    onChange={handleExpenseFileChange}
                  />
                  {imagePreviews.backSideReceipt && (
                    <img
                      src={imagePreviews.backSideReceipt}
                      alt="Back Receipt"
                      style={{ width: "100%", marginTop: "10px" }}
                    />
                  )}
                </div>
              </div>
            </div>
            {/* Action Buttons */}
            <div className="action-buttons-expense">
              <button
                className="action-button-expense edit-button-expense"
                onClick={clearExpense}
              >
                Reset
              </button>
              <button
                className="action-button-expense delete-button-expense"
                onClick={handleSaveExpense}
              >
                Save
              </button>
            </div>

          </div>
        )}
        {activeTab === "income" && (
          <div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <input
                className="inputfield"
                type="date"
                name="date"
                value={incomeFormData.date}
                onChange={handleIncomeChange}
              />
              <select
                className="inputfield"
                name="source"
                value={incomeFormData.source}
                onChange={handleIncomeChange}
              >
                <option value="">Select Income Source</option>
                <option value="salary">Salary</option>
                <option value="freelance">Freelance</option>
                <option value="investment">Investment</option>
                <option value="others">Other</option>
              </select>
              <input
                className="inputfield"
                type="text"
                name="description"
                placeholder="Description (Optional)"
                value={incomeFormData.description}
                onChange={handleIncomeChange}
              />
              <input
                className="inputfield"
                type="text"
                name="amount"
                placeholder="Total"
                value={incomeFormData.amount}
                onChange={handleIncomeChange}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                }}
              />
            </div>
            <div className="action-buttons-expense">
              <button
                className="action-button-expense edit-button-expense"
                onClick={clearIncome}
              >
                Reset
              </button>
              <button
                className="action-button-expense delete-button-expense"
                onClick={handleSaveIncome}
              >
                Save
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AddNewExpense;
